import { render, staticRenderFns } from "./QualityControlReportDetail.vue?vue&type=template&id=caec7fa0&scoped=true"
import script from "./QualityControlReportDetail.vue?vue&type=script&lang=js"
export * from "./QualityControlReportDetail.vue?vue&type=script&lang=js"
import style0 from "./QualityControlReportDetail.vue?vue&type=style&index=0&id=caec7fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec7fa0",
  null
  
)

export default component.exports